type TValidatorFn = (value: any) => string | Promise<string>

export function checkIfDefined<T = any>(checkFn: TValidatorFn) {
  return (value: T) => {
    if (!(value === null || value === undefined)) {
      return checkFn(value)
    }

    return ''
  }
}

export const checkIfDefinedAsync = (checkFn: TValidatorFn) => (value: any) =>
  Promise.resolve(checkIfDefined(checkFn)(value))
